export const HTTP_STATUS = {
    Forbidden: 403,
    Unauthorized: 401,
    NotFound: 404,
    BadRequest: 400,
    Conflict: 409,
    InternalServerError: 500,
    Ok: 200,
};
